var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0588 9.26758V5.78523C16.0588 4.2039 16.0588 3.41324 15.7511 2.80925C15.4804 2.27797 15.0484 1.84603 14.5172 1.57532C13.9132 1.26758 13.1225 1.26758 11.5412 1.26758H5.51765C3.93632 1.26758 3.14566 1.26758 2.54167 1.57532C2.01039 1.84603 1.57845 2.27797 1.30775 2.80925C1 3.41324 1 4.2039 1 5.78523V15.5735C1 17.1548 1 17.9454 1.30775 18.5494C1.57845 19.0807 2.01039 19.5127 2.54167 19.7834C3.14566 20.0911 3.93632 20.0911 5.51765 20.0911H8.52941M10.4118 9.73817H4.76471M6.64706 13.5029H4.76471M12.2941 5.97346H4.76471M14.1765 19.1499V13.5029M11.3529 16.3264H17",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.95c8b6d5a72a13d71cd3ebbf4a447e9f.svg";
export { ForwardRef as ReactComponent };